
<template>
  <v-container fluid>
    <v-row class="status-header">
      <v-col class="physical-status">
        <h3 class="queue-time-header-nega">Jonotusaika</h3>
        <div class="queue-time-value-nega">{{queueTime}} min</div>
      </v-col>
      <v-col class="physical-status">
        <h3 class="queue-time-header-nega">Fyysinen Jono</h3>
        <div class="queue-time-value-nega">{{physicalQueueTime}} min</div>
      </v-col>
      <v-col>
        <v-text-field dark clearable outlined v-model="label" label="Päivitä fyysinen jono" />
        <v-btn
          dark
          outlined
          @click="updatePhysicalQueue"
          color="success"
          class="margin-block"
          width="100%"
        >Päivitä</v-btn>
      </v-col>
    </v-row>
    <v-row class="slot-table">
      <v-col>
        <v-row class="slot-row header">
          <v-col class="xs3 slot-time">Aika</v-col>
          <v-col class="xs3 slot-number">Jonotus nro</v-col>
          <v-col class="xs3 slot-persons">Henkilöä</v-col>
          <v-col class="xs3 slot-persons">Lastaa</v-col>
        </v-row>
        <v-row
          class="slot-row data slot-row--loaded"
          v-for="slotUsed in slotsUsed"
          :key="slotUsed.slotID"
        >
          <v-col class="xs3 slot-time">{{format(slotUsed.loadTime, "H:mm")}}</v-col>
          <v-col class="xs3 slot-number">{{slotUsed.slotID}}</v-col>
          <v-col class="xs3 slot-persons">{{slotUsed.amount}} / 6</v-col>
          <v-col class="xs3">
            <v-btn depressed disabled text width="100%" class="margin-block">
              <v-icon>check</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="slot-divider"></v-col>
        </v-row>

        <v-row class="slot-row data" v-for="slotH in slotsUnusedHistory" :key="slotH.slotID">
          <v-col class="xs3 slot-time">{{format(slotH.loadTime, "H:mm")}}</v-col>
          <v-col class="xs3 slot-number">{{slotH.slotID}}</v-col>
          <v-col class="xs3 slot-persons">{{slotH.amount}} / 6</v-col>
          <v-col class="xs3 slot-buttons">
            <v-btn
              depressed
              width="100%"
              color="#00ADEE"
              dark
              class="white--text margin-block"
              @click="finaliseSlotHandler(slotH.slotID)"
            >
              <v-icon>check</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="slot-divider-future"></v-col>
        </v-row>
        <v-row class="slot-row data" v-for="slotF in slotsUnusedFuture" :key="slotF.slotID">
          <v-col class="xs3 slot-time">{{format(slotF.loadTime, "H:mm")}}</v-col>
          <v-col class="xs3 slot-number">{{slotF.slotID}}</v-col>
          <v-col class="xs3 slot-persons">{{slotF.amount}} / 6</v-col>
          <v-col class="xs3 slot-buttons">
            <v-btn
              depressed
              width="100%"
              color="#00ADEE"
              dark
              class="white--text margin-block"
              @click="finaliseSlotHandler(slotF.slotID)"
            >
              <v-icon>check</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { format } from 'date-fns';
import 'es6-promise/auto';

import { getQueue } from '../APIService';
import { mapGetters, mapActions } from 'vuex';
const APIService = require('../APIService.js');

export default {
  name: 'Dashboard',
  data: function() {
    return {
      label: 0,
    };
  },
  computed: {
    ...mapGetters(['queueTime', 'physicalQueueTime', 'queueSlots']),
    format() {
      return format;
    },
    slotsUnused: function() {
      return this.queueSlots
        .filter(slot => slot.loaded === false)
        .map(slot => {
          slot.amount = 6 - slot.spotsAvailable;
          return slot;
        });
    },
    slotsUnusedFuture: function() {
      return this.queueSlots
        .filter(slot => slot.loaded === false)
        .filter(slot => slot.loadTime >= new Date().getTime())
        .map(slot => {
          slot.amount = 6 - slot.spotsAvailable;
          return slot;
        });
    },
    slotsUnusedHistory: function() {
      return this.queueSlots
        .filter(slot => slot.loaded === false)
        .filter(slot => slot.loadTime <= new Date().getTime())
        .map(slot => {
          slot.amount = 6 - slot.spotsAvailable;
          return slot;
        });
    },
    slotsUsed: function() {
      const unusedSlots = this.queueSlots.filter(slot => slot.loaded);
      const lastTwoUnusedSlots = unusedSlots.slice(Math.max(unusedSlots.length - 2, 0));
      return lastTwoUnusedSlots.map(slot => ({ ...slot, amount: 6 - slot.spotsAvailable }));
    },
  },
  methods: {
    ...mapActions(['refreshQueueTime', 'setQueueTime', 'refreshPhysicalQueueTime', 'finalizeSlot']),
    updatePhysicalQueue: async function() {
      const timeInNumber = Number(this.label);
      const timeInMS = timeInNumber * 60 * 1000;
      await this.setQueueTime(timeInMS);
    },
    finaliseSlotHandler: async function(slotId) {
      this.finalizeSlot(slotId);
    },
  },
};
</script>

<style>
.status-header {
  background: #000;
  box-shadow: 2px 2px 5px #ccc;
  padding: 20px 20px;
  margin-top: -12px;
  vertical-align: middle;
}
.wheel {
  background-color: blue;
  width: 250px;
  height: 250px;
  border-radius: 125px;
}

.status-row {
  margin: 10px 0;
}

.slot-divider {
  background-color: #8fddeb;
  height: 10px;
  padding: 0;
}

.slot-divider-future {
  background-color: #eb928f;
  height: 10px;
  padding: 0;
}

.queue-status {
  background-color: black;
  color: white;
  font-size: 32px;
}

.queue-status > .row,
.physical-status > .row {
  text-align: center;
  justify-content: center;
}

.physical-status {
  align-items: center;
  text-align: center;
  margin-top: 40px;
}

.queue-time-header-nega {
  font-size: 0.9em;
  font-weight: 400;
  color: #f0f0f0 !important;
  text-transform: uppercase;
}
.queue-time-value-nega {
  font-size: 3em;
  font-weight: 900;
  margin: 8px 0;
  color: #a9e8ff;
}

.slot-table {
  padding: 0 24px;
}

.slot-row {
  border-bottom: 1px solid lightgray;
}

.slot-row--loaded {
  background-color: #e9f7f9;
  opacity: 0.7;
  border-bottom: none;
}

.slot-row.header {
  font-size: 1em !important;
  font-weight: 500;
  text-transform: uppercase;
}

.slot-row.data {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  font-weight: 500;
  text-transform: uppercase;
}

.v-text-field__prefix {
  color: #fff !important;
}
</style>